import PostbackHistoryActions from '../../../../actions/PostbackHistoryActions';
import PostbackActions from '../../../../actions/PostbackActions';
import query from '../../../../helpers/query';

let filterParams;
export const actions = {

    getListHistoryPostbacks(state) {
        const parsed = query.parseToSend(state);
        const safe = Object.keys(parsed).reduce((acc, key) => {
            const val = parsed[key];
            if (val === undefined || val === null || val === '') return acc;
            acc[key] = val;
            return acc;
        }, {});
        filterParams = safe;
        PostbackHistoryActions.getListHistoryPostbacks(safe);
    },

    getListPostbacks() {
        PostbackActions.getListPostbacks();
    },

    onResendPostback(state) {
        PostbackHistoryActions.resendPostback({
            id: state.resendPostbackId
        }, () => {
            this.getListHistoryPostbacks(filterParams);
        });
    }
};
